<template>
  <div class="flex h-40 flex-col items-center justify-center space-y-4 px-4">
    <i v-html="itemLogo(getSelectedAccount.broker_name)" class="h-20 w-20 sm:h-28 sm:w-28 xs:h-24 xs:w-24"></i>
    <div class="flex items-center justify-center space-x-2">
      <span class="text-lg text-ontick-carbon-900 dark:text-gray-400"> #{{ getSelectedAccount.account_number }} </span>
      <span
        class="flex h-5 w-5 items-center justify-center rounded text-xs font-bold"
        :class="
          getSelectedAccount.account_type === 'DEMO'
            ? 'bg-gray-500 text-gray-200'
            : 'bg-ontick-blue-900 text-ontick-blue-500'
        "
      >
        {{ getSelectedAccount.account_type === "DEMO" ? "D" : "P" }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
    }),
  },
  methods: {
    itemLogo(value) {
      let img;
      if (value == "OnTick") {
        img = this.$icons.ontick;
      } else if (value == "XP") {
        img = this.$icons.xp;
      } else if (value == "Cripto") {
        img = this.$icons.bitcoin;
      }
      return img;
    },
  },
  // created() {
  //   console.log(this.getSelectedAccount);
  // },
};
</script>

<style></style>
